<template>
  <div id="footer" class="position-relative">
    <section class="charactor position-absolute bottom-0 right-0 mb-5 mb-lg-5">
      <img
        :src="require('@/assets/img/character-both-normal.svg')"
        class="charactor-img mr-4 mb-2"
        alt="마술소 캐릭터"
      />
    </section>
    <footer class="container-fluid py-3 bg-grey-dark">
      <ul
        class="list-unstyled d-flex flex-column flex-md-row align-items-start align-items-md-center text-white text-lg-14 mt-3"
      >
        <li class="ml-md-auto mr-3 break-keep d-flex flex-md-row flex-column">
          <span class="mb-2 mb-md-0 mr-md-2">
            (사)마을예술네트워크
          </span>
          <span class="mb-2 mb-md-0 mr-md-2"
            >tel:
            <a href="tel:02-323-1575" class="text-white">02-323-1575</a>
          </span>
          <span class="mb-2 mb-md-0 mr-md-2">
            e-mail:
            <a href="emailto:maulartnet@naver.com" class="text-white"
              >maulartnet@naver.com</a
            >
          </span>
        </li>
        <li class="ml-0 mr-0">
          &copy; Copyright 2020, All Rights Reserved artmasulso.net
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.charactor-img {
  width: 12rem !important;
  @media all and (min-width: 768px) and (max-width: 1024px) {
    width: 8rem !important;
  }
  @media all and (max-width: 768px) {
    margin-bottom: 4.5rem !important;
    width: 8rem !important;
  }
  height: auto;
}
a.text-white {
  &:hover {
    text-decoration: underline !important;
  }
}
</style>
